(function () {
  function money(cents) {
    var cur = 'USD';
    var vs = document.querySelector('variant-selects');
    if (vs && vs.dataset.currencyCode) cur = vs.dataset.currencyCode;
    else if (window.Shopify && Shopify.currency && Shopify.currency.active) cur = Shopify.currency.active;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function parseMoney(text) {
    var n = (text || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var f = parseFloat(n);
    return isNaN(f) ? null : Math.round(f * 100);
  }
  function variantCents() {
    // 1) INSTANT: price shown on the currently-selected variant card (no network wait)
    var card = document.querySelector('.product-form__input--pill input[type="radio"]:checked + label .variant-price');
    if (card) { var c = parseMoney(card.textContent); if (c != null) return c; }
    // 2) selected variant JSON (updated after Dawn's fetch)
    var s = document.querySelector('[data-selected-variant]');
    if (s) { try { var v = JSON.parse(s.textContent); if (v && typeof v.price === 'number') return v.price; } catch (e) {} }
    // 3) visible price element fallback
    var p = document.querySelector('.price__regular .price-item--regular, .price-item--regular, .price .money');
    if (p) { var pc = parseMoney(p.textContent); if (pc != null) return pc; }
    return null;
  }
  function qtyVal() {
    var q = document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n > 0 ? n : 1);
  }
  function getBtn() {
    return document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]');
  }
  // dedicated price span Dawn never touches -> no text flicker on variant change
  function priceSpan(b) {
    var s = b.querySelector('.jb-atc-price');
    if (!s) { s = document.createElement('span'); s.className = 'jb-atc-price'; b.appendChild(s); }
    return s;
  }
  function soldOut(b) {
    if (!(b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true')) return false;
    var main = b.querySelector('span:not(.jb-atc-price)');
    var t = (main ? main.textContent : '').toLowerCase();
    return t.indexOf('sold') > -1 || t.indexOf('unavailable') > -1;
  }
  // sync the main product price (below the title) instantly with the selected variant card
  function syncMainPrice() {
    var card = document.querySelector('.product-form__input--pill input[type="radio"]:checked + label .variant-price');
    if (!card) return;
    var txt = (card.textContent || '').trim();
    if (!txt) return;
    document.querySelectorAll('.product__info-container .price__regular .price-item--regular').forEach(function (el) {
      if (el.textContent.trim() !== txt) el.textContent = txt;
    });
  }
  function update() {
    syncMainPrice();
    var b = getBtn(); if (!b) return;
    var span = priceSpan(b);
    if (soldOut(b)) { if (span.textContent !== '') span.textContent = ''; return; }
    var cents = variantCents(); if (cents == null) return;
    var next = ' - ' + money(cents * qtyVal());
    if (span.textContent !== next) span.textContent = next; // only updates the number, main label stays put
  }
  function bind() {
    var q = document.querySelector('input[name="quantity"]');
    if (q) { q.addEventListener('change', update); q.addEventListener('input', update); }
    document.addEventListener('change', function (ev) { if (ev.target && ev.target.name === 'quantity') update(); });
    // INSTANT price on variant click (fires before Dawn's fetch finishes)
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('.product-form__input--pill input[type="radio"]')) update();
    });

    var b = getBtn();
    if (b) new MutationObserver(function () { setTimeout(update, 0); }).observe(b, { childList: true, subtree: true, characterData: true });
    var vs = document.querySelector('variant-selects');
    if (vs) new MutationObserver(function () { setTimeout(update, 0); }).observe(vs, { childList: true, subtree: true, characterData: true });

    update();
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
